import { render, staticRenderFns } from "./DeliveryReport.vue?vue&type=template&id=18b1726e&"
import script from "./DeliveryReport.vue?vue&type=script&lang=js&"
export * from "./DeliveryReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports